import Choices from 'choices.js';

export function initSelects() {
    $('select.select').each((key, item) => {
        if($(item).data('tournament-select') !== '' && $(item).data('conference-select') === undefined){
            initChoices(item);
        }
    });

    function initChoices($element, options = {
        searchEnabled: false,
        silent: true,
        itemSelectText: '',
        allowHTML: true,
        position: 'right'
    }) {
        if (!$element) return;

        new Choices($element, options);
    }
}